import React from "react"

import StoryblokLink from "../shared/StoryblokLink"

import { renderCardHeadline } from "../contentEdit"

import { ThreeCardWebinarSelection } from "../../types"

type ResourceCaseStudyCardProps = {
  content: ThreeCardWebinarSelection
  ctaText: string
}

const ResourceCaseStudyCard = ({
  content,
  ctaText,
}: ResourceCaseStudyCardProps) => {
  const linkObject = {
    cached_url: content?.full_slug,
    linktype: "story",
  }

  const cardHeadline = renderCardHeadline(
    content?.content?.webinarTitle,
    "c-resourceCaseStudyCard__heading"
  )

  return (
    <StoryblokLink to={linkObject} className="c-resourceCaseStudyCard">
      <div className="c-resourceCaseStudyCard__hoverWrapper">
        <div
          className="c-resourceCaseStudyCard__imageWrapper"
          style={{
            backgroundImage: `url(${content?.content?.image?.filename})`,
          }}
        />

        <div className="c-resourceCaseStudyCard__content">
          <p className="c-resourceCaseStudyCard__type">
            {content?.content?.component}
          </p>

          {cardHeadline}

          <p className="c-resourceCaseStudyCard__webinarDate">
            {content?.content?.date}
          </p>

          <span className="btn-tertiary hover-bcgUnderline">{ctaText}</span>
        </div>
      </div>
    </StoryblokLink>
  )
}

export default ResourceCaseStudyCard
